import styled from 'styled-components';

export const Wrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
